import React from 'react';
import PropTypes from 'prop-types';
import { getBEMClasses } from '../../../helpers/cssClassesHelper';
import './Spinner.css';
var spinnerClasses = getBEMClasses('spinner');
var Spinner = function Spinner(_ref) {
  var isVisible = _ref.isVisible,
    isInline = _ref.isInline,
    text = _ref.text,
    customClass = _ref.customClass,
    classModifiers = _ref.classModifiers;
  var baseClass = typeof customClass === 'string' ? getBEMClasses(customClass) : customClass || function () {
    return '';
  };
  return React.createElement(React.Fragment, null, isVisible && React.createElement('div', {
    className: spinnerClasses('container', isInline && 'inline') + ' ' + baseClass('spinner-container', classModifiers)
  }, React.createElement('div', {
    className: spinnerClasses('circle', isInline && 'inline') + ' ' + baseClass('spinner-circle', classModifiers)
  }), text && React.createElement('div', {
    className: spinnerClasses('text')
  }, text)));
};
Spinner.propTypes = {
  isInline: PropTypes.bool,
  isVisible: PropTypes.bool.isRequired,
  customClass: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  text: PropTypes.string
};
Spinner.defaultProps = {
  isVisible: true
};
export default Spinner;